import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=05f927a5&"
import script from "./FileView.vue?vue&type=script&lang=js&"
export * from "./FileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f927a5')) {
      api.createRecord('05f927a5', component.options)
    } else {
      api.reload('05f927a5', component.options)
    }
    module.hot.accept("./FileView.vue?vue&type=template&id=05f927a5&", function () {
      api.rerender('05f927a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/FileView.vue"
export default component.exports